import type { ReactNode } from 'react';
import type { Message } from '../../types/agent';
import { Timestamp } from './Timestamp';
import { renderWa } from '../../lib/waMarkdown';
import { CotacaoCard } from './CotacaoCard';
import { SublingualOffer } from './SublingualOffer';

export function BotBubble({ message, children }: { message: Message; children?: ReactNode }) {
  return (
    <div
      className="bg-white text-[#0A0A0A] text-[15px] md:text-[14px] leading-[1.45] rounded-[18px] shadow-[0_1px_1px_rgba(0,0,0,0.05)] px-3 py-2 max-w-[85%] md:max-w-[65%] wa-bubble-enter relative"
    >
      <div className="whitespace-pre-wrap">{renderWa(message.text)}</div>
      {message.cotacao && <CotacaoCard cotacao={message.cotacao} cotacoes={message.cotacoes} />}
      {message.ofertaAlt && <SublingualOffer oferta={message.ofertaAlt} />}
      {children && <div className="mt-2">{children}</div>}
      <div className="flex justify-end mt-1">
        <Timestamp epochMs={message.timestamp} />
      </div>
      {message.priceWarning && (
        <div
          role="alert"
          className="bg-[#FFF9E6] text-[#B7791F] text-[11px] rounded-b-[8px] mt-1 -mx-2 -mb-1.5 px-2 py-1"
        >
          {message.priceWarning}
        </div>
      )}
    </div>
  );
}
